export default class SmsTemplatesListPageController {
    constructor($scope, $injector) {
        this.scope = $scope;
        this.injector = $injector;
        this.translate = this.injector.get('$translate');

        this._initStore();
    }

    _initStore() {
        this.store = this.injector.get('SmsTemplates');
        this.store.commit('setVm', this);
        this.store.dispatch('loadWorkflows', 'messages::sms-template-list');
    }
}

SmsTemplatesListPageController.$inject = [
    '$scope',
    '$injector'
];



// WEBPACK FOOTER //
// ./src/app/modules/messages/controllers/pages/sms/templates/list.js